import { render, staticRenderFns } from "./ConfirmView.vue?vue&type=template&id=53fe3fa2&scoped=true"
import script from "./ConfirmView.vue?vue&type=script&lang=js"
export * from "./ConfirmView.vue?vue&type=script&lang=js"
import style0 from "./ConfirmView.vue?vue&type=style&index=0&id=53fe3fa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe3fa2",
  null
  
)

export default component.exports